module.exports = __webpack_public_path__ + "img/block6-card4.15e91bd1.svg";